import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectIsAuthenticated, selectUser } from "@/features/auth/store/sessionSlice";
import { FeatureTeasingService } from "@/shared/services/featureTeasing.service";

export const useCurrentOffers = () => {
  const authenticated = useSelector(selectIsAuthenticated);
  const representative = useSelector(selectUser)?.representative;
  const organizationId = representative?.organization_id ?? "";
  const [clock, setClock] = useState(Date.now);
  const query = useQuery({
    queryKey: ["current-offers", organizationId, representative?.id],
    enabled: authenticated && !!organizationId && !!representative?.id,
    queryFn: async ({ signal }) => {
      const result = await FeatureTeasingService.list(organizationId, signal);
      return { ...result, offset: Date.parse(result.server_time) - Date.now() };
    },
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: true,
  });
  const now = Math.max(clock, Date.now()) + (query.data?.offset ?? 0);
  const campaigns = query.data?.campaigns.filter((campaign) => Date.parse(campaign.ends_at) > now) ?? [];
  const nextExpiry = campaigns[0]?.ends_at;
  const refetch = query.refetch;
  useEffect(() => {
    if (!nextExpiry) return;
    const delay = Math.max(1, Date.parse(nextExpiry) - Date.now() - (query.data?.offset ?? 0));
    const timer = window.setTimeout(() => {
      setClock(Date.now());
      void refetch();
    }, Math.min(delay, 2_147_483_647));
    return () => window.clearTimeout(timer);
  }, [nextExpiry, query.data?.offset, refetch, clock]);
  return { ...query, campaigns, organizationId };
};
